var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.0002 4.35071C12.4317 4.35071 3.8335 12.9489 3.8335 23.5174C3.8335 34.0859 12.4317 42.684 23.0002 42.684C33.5687 42.684 42.1668 34.0859 42.1668 23.5174C42.1668 12.9489 33.5687 4.35071 23.0002 4.35071ZM23.0002 38.8507C14.5457 38.8507 7.66683 31.9718 7.66683 23.5174C7.66683 15.063 14.5457 8.18404 23.0002 8.18404C31.4546 8.18404 38.3335 15.063 38.3335 23.5174C38.3335 31.9718 31.4546 38.8507 23.0002 38.8507Z","fill":"#85C3B3"}));
}

Circle.defaultProps = {"width":"46","height":"47","viewBox":"0 0 46 47","fill":"none"};

module.exports = Circle;

Circle.default = Circle;
